import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row mb-6 align-items-center"
}
const _hoisted_2 = { class: "col-lg-4 col-form-label fw-bold fs-5" }
const _hoisted_3 = { class: "col-lg-8 d-flex" }
const _hoisted_4 = { class: "row mb-6" }
const _hoisted_5 = { class: "col-lg-4 col-form-label fw-bold fs-5" }
const _hoisted_6 = { class: "col-lg-8 fv-row" }
const _hoisted_7 = { class: "fv-plugins-message-container" }
const _hoisted_8 = { class: "fv-help-block text-end" }
const _hoisted_9 = { class: "row mb-6" }
const _hoisted_10 = { class: "col-lg-4 col-form-label fw-bold fs-5" }
const _hoisted_11 = { class: "col-lg-8 fv-row" }
const _hoisted_12 = { class: "fv-plugins-message-container" }
const _hoisted_13 = { class: "fv-help-block text-end" }
const _hoisted_14 = { class: "row mb-6" }
const _hoisted_15 = { class: "col-lg-4 col-form-label fw-bold fs-5" }
const _hoisted_16 = { class: "col-lg-8 fv-row" }
const _hoisted_17 = { class: "fv-plugins-message-container" }
const _hoisted_18 = { class: "fv-help-block text-end" }
const _hoisted_19 = { class: "row mb-6" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Régions de rattachement")
], -1)
const _hoisted_21 = { class: "col-lg-8 fv-row" }
const _hoisted_22 = { class: "fv-plugins-message-container" }
const _hoisted_23 = { class: "fv-help-block text-end" }
const _hoisted_24 = { class: "row mb-6" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-5" }, [
  /*#__PURE__*/_createElementVNode("span", null, " Précisions sur le projet, les finalités...")
], -1)
const _hoisted_26 = { class: "col-lg-8 fv-row" }
const _hoisted_27 = ["disabled"]
const _hoisted_28 = { class: "fv-plugins-message-container" }
const _hoisted_29 = { class: "fv-help-block text-end" }
const _hoisted_30 = { class: "row mb-6" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-5" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Partenaires du projet")
], -1)
const _hoisted_32 = { class: "col-lg-8 fv-row" }
const _hoisted_33 = ["disabled"]
const _hoisted_34 = { class: "fv-plugins-message-container" }
const _hoisted_35 = { class: "fv-help-block text-end" }
const _hoisted_36 = {
  key: 1,
  class: "notice d-flex flex-column flex-sm-row align-items-center bg-light-warning rounded border-warning border border-dashed mb-9 p-6"
}
const _hoisted_37 = { class: "svg-icon svg-icon-2tx svg-icon-warning m-4" }
const _hoisted_38 = { class: "d-flex flex-stack flex-grow-1" }
const _hoisted_39 = { class: "fw-bold" }
const _hoisted_40 = { class: "text-gray-800 fw-bolder" }
const _hoisted_41 = {
  "data-bs-target": "#infoBiodiversityProgress",
  class: "svg-icon cursor-pointer svg-icon-2x svg-icon-dark",
  "data-bs-toggle": "modal"
}
const _hoisted_42 = /*#__PURE__*/_createElementVNode("p", { class: "fs-6 text-gray-600" }, " La collecte et le traitement de ces « indicateurs de pressions », ainsi que la construction « d’indicateur biodiversité » et leur interprétation sont sous responsabilité du \"prescripteur\" et n'engagent pas les co-fondateurs d'AgriBEST Nous alertons notamment les prescripteurs sur le risque d’alourdissement de l’outil (pour les utilisateurs) en cas d’un nombre trop important d’indicateurs. Il est donc important de bien expliciter l’intérêt commun de cette collecte de données supplémentaire. ", -1)
const _hoisted_43 = { class: "row mb-6" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-5" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Indicateurs Additionnels Obligatoires")
], -1)
const _hoisted_45 = { class: "col-lg-8 fv-row" }
const _hoisted_46 = { class: "fv-plugins-message-container" }
const _hoisted_47 = { class: "fv-help-block text-end" }
const _hoisted_48 = { class: "row mb-6" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-5" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Indicateurs Additionnels Optionnels")
], -1)
const _hoisted_50 = { class: "col-lg-8 fv-row" }
const _hoisted_51 = { class: "fv-plugins-message-container" }
const _hoisted_52 = { class: "fv-help-block text-end" }
const _hoisted_53 = ["disabled"]
const _hoisted_54 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Enregistrer ", -1)
const _hoisted_55 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Veuillez patienter... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_56 = [
  _hoisted_54,
  _hoisted_55
]
const _hoisted_57 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Retour ", -1)
const _hoisted_58 = [
  _hoisted_57
]
const _hoisted_59 = {
  id: "infoBiodiversityProgress",
  class: "modal fade",
  tabindex: "-1"
}
const _hoisted_60 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_61 = { class: "modal-content" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "modal-title" }, " Détails des choix pour les démarches de progrès en matière de Biodiversité "),
  /*#__PURE__*/_createElementVNode("div", {
    "aria-label": "Close",
    class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
    "data-bs-dismiss": "modal"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2x" })
  ])
], -1)
const _hoisted_63 = { class: "modal-body" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("div", { class: "modal-footer" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-primary",
    "data-bs-dismiss": "modal"
  }, " J'ai compris ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createBlock(_component_Form, {
    validateOnMount: "",
    "validation-schema": _ctx.projectContentValidator,
    class: "form",
    onSubmit: _ctx.onSubmitProjectContent
  }, {
    default: _withCtx(({ values }) => [
      (
        _ctx.mode !== 'display' &&
        _ctx.mode !== 'display-founders' &&
        _ctx.projectContent.state === 1
      )
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("label", _hoisted_2, [
              _createElementVNode("span", {
                class: _normalizeClass(
            _ctx.mode === 'display' || _ctx.mode === 'display-founders' ? '' : 'required'
          )
              }, "Accepter la charte prescripteurs", 2)
            ]),
            _createElementVNode("div", _hoisted_3, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input",
                type: "checkbox",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.prescriberCharterAccepted) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.prescriberCharterAccepted]
              ]),
              _createElementVNode("p", {
                class: "w-xl-25 mb-0 ms-2 text-primary cursor-pointer",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push({ name: 'prescriber-charter' })))
              }, " Voir la charte ")
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("label", _hoisted_5, [
          _createElementVNode("span", {
            class: _normalizeClass(
            _ctx.mode === 'display' || _ctx.mode === 'display-founders' ? '' : 'required'
          )
          }, "Nom du projet", 2)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_Field, {
            modelValue: _ctx.projectContent.name,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.projectContent.name) = $event)),
            class: "form-control form-control-lg form-control-solid",
            name: "name",
            placeholder: "Nom du projet",
            type: "text",
            disabled: _ctx.mode === 'display' || _ctx.mode === 'display-founders'
          }, null, 8, ["modelValue", "disabled"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_ErrorMessage, { name: "name" })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("label", _hoisted_10, [
          _createElementVNode("span", {
            class: _normalizeClass(
            _ctx.mode === 'display' || _ctx.mode === 'display-founders' ? '' : 'required'
          )
          }, "Finalité(s) du projet", 2)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_Multiselect, {
            modelValue: _ctx.projectContent.project_purposes,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.projectContent.project_purposes) = $event)),
            "close-on-select": false,
            searchable: true,
            "create-option": true,
            options: 
            _ctx.projectPurposes.map((r) => {
              return { value: r.number, label: r.description };
            })
          ,
            mode: "tags",
            name: "gdpr_purposes",
            disabled: _ctx.mode === 'display' || _ctx.mode === 'display-founders'
          }, null, 8, ["modelValue", "options", "disabled"])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_ErrorMessage, { name: "gdpr_purposes" })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("label", _hoisted_15, [
          _createElementVNode("span", {
            class: _normalizeClass(
            _ctx.mode === 'display' || _ctx.mode === 'display-founders' ? '' : 'required'
          )
          }, "Finalité(s) d'utilisation des données", 2)
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_Multiselect, {
            modelValue: _ctx.projectContent.gdpr_purposes,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.projectContent.gdpr_purposes) = $event)),
            "close-on-select": false,
            searchable: true,
            "create-option": true,
            options: 
            _ctx.gdprPurposes.map((r) => {
              return { value: r.number, label: r.description };
            })
          ,
            mode: "tags",
            name: "gdpr_purposes",
            disabled: _ctx.mode === 'display' || _ctx.mode === 'display-founders'
          }, null, 8, ["modelValue", "options", "disabled"])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_component_ErrorMessage, { name: "gdpr_purposes" })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _hoisted_20,
        _createElementVNode("div", _hoisted_21, [
          _createVNode(_component_Multiselect, {
            modelValue: _ctx.projectContent.region,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.projectContent.region) = $event)),
            "close-on-select": false,
            searchable: true,
            "create-option": true,
            options: 
            _ctx.regions.map((r) => {
              return { value: r.id, label: r.name };
            })
          ,
            mode: "tags",
            name: "regions",
            placeholder: "France entière si laissé vide",
            disabled: _ctx.mode === 'display' || _ctx.mode === 'display-founders'
          }, null, 8, ["modelValue", "options", "disabled"])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createVNode(_component_ErrorMessage, { name: "regions" })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_24, [
        _hoisted_25,
        _createElementVNode("div", _hoisted_26, [
          _createVNode(_component_Field, {
            modelValue: _ctx.projectContent.details,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.projectContent.details) = $event)),
            class: "form-control form-control-lg form-control-solid",
            name: "description",
            disabled: _ctx.mode === 'display' || _ctx.mode === 'display-founders',
            style: { height: '200px' }
          }, {
            default: _withCtx(({ field }) => [
              _createElementVNode("textarea", _mergeProps(field, {
                placeholder: "Description du projet",
                class: "w-100 h-100px",
                disabled: _ctx.mode === 'display' || _ctx.mode === 'display-founders'
              }), null, 16, _hoisted_27)
            ]),
            _: 1
          }, 8, ["modelValue", "disabled"])
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _createVNode(_component_ErrorMessage, { name: "description" })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_30, [
        _hoisted_31,
        _createElementVNode("div", _hoisted_32, [
          _createVNode(_component_Field, {
            modelValue: _ctx.projectContent.partners,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.projectContent.partners) = $event)),
            class: "form-control form-control-lg form-control-solid",
            name: "partners",
            disabled: _ctx.mode === 'display' || _ctx.mode === 'display-founders',
            style: { height: '100px' }
          }, {
            default: _withCtx(({ field }) => [
              _createElementVNode("textarea", _mergeProps(field, {
                placeholder: "Partenaires du projet",
                class: "w-100 h-100px",
                disabled: _ctx.mode === 'display' || _ctx.mode === 'display-founders'
              }), null, 16, _hoisted_33)
            ]),
            _: 1
          }, 8, ["modelValue", "disabled"])
        ]),
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _createVNode(_component_ErrorMessage, { name: "partners" })
          ])
        ])
      ]),
      (_ctx.mode !== 'display')
        ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
            _createElementVNode("span", _hoisted_37, [
              _createVNode(_component_inline_svg, {
                src: require('@/../public/media/icons/duotune/general/gen044.svg')
              }, null, 8, ["src"])
            ]),
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("h4", _hoisted_40, [
                  _createTextVNode(" Indicateurs de pression "),
                  _createElementVNode("span", _hoisted_41, [
                    _createVNode(_component_inline_svg, {
                      src: 
                  require('@/../public/media/icons/duotune/general/gen046.svg')
                
                    }, null, 8, ["src"])
                  ])
                ]),
                _hoisted_42
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_43, [
        _hoisted_44,
        _createElementVNode("div", _hoisted_45, [
          _createVNode(_component_Multiselect, {
            modelValue: _ctx.selectedMandatoryIndicators,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.selectedMandatoryIndicators) = $event)),
            "close-on-select": false,
            searchable: true,
            "create-option": true,
            options: 
            _ctx.indicators
              .filter((i) => !_ctx.selectedOptionalIndicators.includes(i.id))
              .map((r) => {
                return { value: r.id, label: r.name };
              })
          ,
            mode: "tags",
            name: "gdpr_purposes",
            disabled: _ctx.mode === 'display-founders'
          }, null, 8, ["modelValue", "options", "disabled"])
        ]),
        _createElementVNode("div", _hoisted_46, [
          _createElementVNode("div", _hoisted_47, [
            _createVNode(_component_ErrorMessage, { name: "gdpr_purposes" })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_48, [
        _hoisted_49,
        _createElementVNode("div", _hoisted_50, [
          _createVNode(_component_Multiselect, {
            modelValue: _ctx.selectedOptionalIndicators,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.selectedOptionalIndicators) = $event)),
            "close-on-select": false,
            searchable: true,
            "create-option": true,
            options: 
            _ctx.indicators
              .filter((i) => !_ctx.selectedMandatoryIndicators.includes(i.id))
              .map((r) => {
                return { value: r.id, label: r.name };
              })
          ,
            mode: "tags",
            name: "gdpr_purposes",
            disabled: _ctx.mode === 'display-founders'
          }, null, 8, ["modelValue", "options", "disabled"])
        ]),
        _createElementVNode("div", _hoisted_51, [
          _createElementVNode("div", _hoisted_52, [
            _createVNode(_component_ErrorMessage, { name: "gdpr_purposes" })
          ])
        ])
      ]),
      (!(_ctx.mode === 'display-founders'))
        ? (_openBlock(), _createElementBlock("button", {
            key: 2,
            ref: "submitButtonProjectContent",
            disabled: 
        !_ctx.projectContentValidator.isValidSync(values) ||
        _ctx.projectContent.gdpr_purposes?.length === 0 ||
        _ctx.projectContent.project_purposes?.length === 0 ||
        !_ctx.prescriberCharterAccepted
      ,
            class: "btn btn-primary me-2",
            type: "submit"
          }, _hoisted_56, 8, _hoisted_53))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        class: "btn btn-warning",
        onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.$router.back && _ctx.$router.back(...args)))
      }, _hoisted_58),
      _createElementVNode("div", _hoisted_59, [
        _createElementVNode("div", _hoisted_60, [
          _createElementVNode("div", _hoisted_61, [
            _hoisted_62,
            _createElementVNode("div", _hoisted_63, [
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.indicators, (item) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: item.value
                  }, [
                    _createElementVNode("strong", null, _toDisplayString(item.name) + " " + _toDisplayString(item.units ? " (" + item.units + ") " : ""), 1),
                    _createTextVNode(" : " + _toDisplayString(item.description), 1)
                  ]))
                }), 128))
              ])
            ]),
            _hoisted_64
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["validation-schema", "onSubmit"]))
}